import { useQuery } from 'react-query';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { FlowsQuestionnaire, FlowTagContent } from '../types/FlowsTypes';

interface Response {
  questionnaire: FlowsQuestionnaire;
  tag_content: FlowTagContent[];
}

interface Params {
  flowId: string;
  partyId?: string;
  disableContentTemplates?: boolean;
}

const getQuestionGroupsByFlowId = async ({
  flowId,
  partyId,
  disableContentTemplates,
}: Params) => {
  const { data, isError } = await wgApi.get<Response>(
    `/v1/api/flows/${flowId}/questionnaire`,
    {
      query: {
        party_id: partyId || undefined,
        disable_content_templates: disableContentTemplates,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

export const getQuestionGroupByFlowIdQKey = (params: Params) => [
  'flows',
  'questionnaire',
  params,
];

export const useQuestionGroups = (params: Params) => {
  return useQuery(
    getQuestionGroupByFlowIdQKey(params),
    () => getQuestionGroupsByFlowId(params),
    { refetchOnMount: false, refetchOnWindowFocus: false },
  );
};
